import React from "react";
import CreatePaymentMethod from "./CreatePaymentMethod";
import {Elements} from '@stripe/react-stripe-js';
import { loadStripe } from "@stripe/stripe-js";
import Axios from 'axios';
import { useState } from "react";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Skeleton } from "@material-ui/lab";
import CreditCardIcon from '@material-ui/icons/CreditCard';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export default function PaymentMethods() {
    const [paymentMethods, setPaymentMethods] = useState([]);
    const {subscription_details} = useSelector(state => state.subscriptionData?.subscriptionData?.original);
    const [fetching, setFetching] = useState(false);
    const [defaultPayment, setDefaultPayment] = useState(null);
    
    const handleFetchPaymentMethods = async () => {
        setFetching(true);
        await Axios.get(`/api/v2/subscriptions/payment_method/${subscription_details.subscription_id}`)
        .then(res => {
            setPaymentMethods(res.data.data);
            setDefaultPayment(res.data.default);
        })
        .catch(err => {
            console.log(err);
        })
        .finally(() => {
            setFetching(false);
        });
    };
    
    const handleSetDefault = async (paymentMethodId) => {
        setFetching(true);
        const dataBuilder = {
            payment_method: paymentMethodId,
            subscription: subscription_details.subscription_id
        };
        
        await Axios.post('/api/v2/subscriptions/update/payment_method', dataBuilder)
        .then(() => {
            handleFetchPaymentMethods();
        })
        .catch((err) => {
            console.log(err);
        })
        .finally(() => {
            setFetching(false);
        });
    };
    
    const isDefaultPaymentMethod = (paymentId) => {
        if(defaultPayment?.id === paymentId){
            return true;
        }
        return false;
    };
    useEffect(() => {
        handleFetchPaymentMethods();
    }, []);

    return(
        <div className="d-flex flex-column">
            <div className="p-5 d-flex flex-row align-items-center">
                <div className="d-flex flex-column">
                    <h1 className="m-0 font-weight-bold">Payment Methods</h1>
                    <p className="m-0 form-text text-muted pt-2">
                        Manage your payment methods for billing.
                    </p>
                </div>
                <Elements stripe={stripePromise}>
                    <CreatePaymentMethod refresh={handleFetchPaymentMethods}/>
                </Elements>
            </div>
            {fetching && Array(3).fill().map((_, index) => (
                <div key={index} className="mt-3 p-5 d-flex flex-row shadow-sm border rounded align-items-center">
                    <Skeleton variant="rect" width="100%" height={50}/>
                </div>
            ))}
            {!fetching && paymentMethods.map((paymentMethod) => (
                <div className="mt-3 p-5 d-flex flex-row shadow-sm border rounded align-items-center">
                    <div className="col-1">
                        <CreditCardIcon fontSize="large" />
                    </div>
                    <div className="d-flex flex-column">
                        <h3 className="m-0 font-weight-bold text-uppercase font-weight-bold">{paymentMethod.card.brand} {paymentMethod.card.last4}</h3>
                        <p className="m-0 form-text text-muted pt-2">
                            Expires on {paymentMethod.card.exp_month}/{paymentMethod.card.exp_year}
                        </p>
                    </div>
                    <div className="ml-auto">
                        <button
                            type="button"
                            className={`btn ${isDefaultPaymentMethod(paymentMethod.id) ? "btn-outline-dark" : "btn-light-primary"} font-weight-bold btn-sm`}
                            style={{
                                borderRadius: "50px"
                            }}
                            onClick={() => handleSetDefault(paymentMethod.id)}
                            disabled={isDefaultPaymentMethod(paymentMethod.id)}
                        >
                            {isDefaultPaymentMethod(paymentMethod.id) ? "Default Payment" : "Set as Default"}
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}